// https://github.com/aFarkas/lazysizes
import lazy from 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/bgset/ls.bgset.js';
import 'lazysizes/plugins/respimg/ls.respimg';